import React, { useState } from "react"
import styled from "styled-components"

import { GetInternPopularBody } from "~/api/intern/popular/_types"
import Typography from "~/components/atoms/Typography"
import { Color, SpacingSize, RadiusSize } from "~/consts/style-mixins"

type Props = {
  intern: GetInternPopularBody
  onClick: (_: string) => void
}

const JobCardPopularLongInternship: React.VFC<Props> = ({ intern, onClick }) => {
  const [mouseMoved, setMouseMoved] = useState(false)

  /** react-slickがDragとClickの違いを認識しない為、Drag中はClick処理を除外 */
  const handleClick = () => {
    if (mouseMoved) {
      return
    }
    onClick(intern.url)
  }

  return (
    <StyledCard
      onMouseMove={() => setMouseMoved(true)}
      onMouseDown={() => setMouseMoved(false)}
      onMouseUp={handleClick}
    >
      <StyledCardHead>
        <Thumbnail src={intern.company.main_img_url} />
        <Heading>
          <StyledCardTitle type="SubLabel">{intern.job_type}</StyledCardTitle>
          <StyledCardSubTitle type="SmallLabel">{intern.company.display}</StyledCardSubTitle>
        </Heading>
      </StyledCardHead>
      <StyledCardBody type="SubLabel">{intern.title}</StyledCardBody>
      <StyledCardFooter>
        <StyledTag type="SubLabel">{intern.prefecture}</StyledTag>
      </StyledCardFooter>
    </StyledCard>
  )
}

const StyledCard = styled.div`
  width: 240px;
  height: 167px;
  background-color: ${Color.White};
  padding: ${SpacingSize.M}px;
  border-radius: ${RadiusSize.Medium}px;
  cursor: pointer;
`

const StyledCardHead = styled.div`
  display: flex;
`

const Thumbnail = styled.div<{ src: string }>`
  width: 47px;
  height: 47px;
  background-image: ${({ src }) => `url("${src}")`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid ${Color.BorderGray};
  border-radius: 50%;
`

const Heading = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  margin-left: ${SpacingSize.S}px;
`

const ellipsisTypograph = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`

const StyledCardTitle = styled(ellipsisTypograph)`
  color: ${Color.Primary};
  -webkit-line-clamp: 2;
`

const StyledCardSubTitle = styled(ellipsisTypograph)`
  color: ${Color.LightGray};
  margin-top: ${SpacingSize._4XS}px;
`

const StyledCardBody = styled(ellipsisTypograph)`
  color: ${Color.Black};
  text-align: left;
  margin-top: ${SpacingSize.XS}px;
  -webkit-line-clamp: 3;
`

const StyledCardFooter = styled.div`
  display: flex;
  text-align: left;
  margin-top: ${SpacingSize.XS}px;
`

const StyledTag = styled(Typography)`
  color: ${Color.Black};
  font-weight: bold;
  background: ${Color.BackgroundGray};
  border-radius: ${RadiusSize.Medium}px;
  padding: 4px 6px;
`

export default JobCardPopularLongInternship
